import styled from 'styled-components'
import MuiAlert from '@material-ui/lab/Alert'

export const StyledMuiAlert = styled(MuiAlert)`
  display: flex;
  align-items: center;
`
